import { formatDay, parseDay, type Day } from '@map-my-money/engine';
import { dateToDay } from './format.ts';

/** `?asOf=YYYY-MM-DD` pins "today" in development and mocked (test) builds only; production always uses the clock. */
export const AS_OF_OVERRIDABLE = import.meta.env.DEV || import.meta.env.VITE_API_MOCK === '1';

const STORAGE_KEY = 'mm.asOf';
const DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

function readOverride(): string | null {
  if (!AS_OF_OVERRIDABLE || typeof window === 'undefined') return null;
  const fromUrl = new URLSearchParams(window.location.search).get('asOf');
  try {
    if (fromUrl && DAY_PATTERN.test(fromUrl)) {
      sessionStorage.setItem(STORAGE_KEY, fromUrl);
      return fromUrl;
    }
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored && DAY_PATTERN.test(stored) ? stored : null;
  } catch {
    return fromUrl && DAY_PATTERN.test(fromUrl) ? fromUrl : null;
  }
}

const override = readOverride();

/** The engine's "today". */
export function todayDay(): Day {
  return override ? parseDay(override) : dateToDay(new Date());
}

export const todayString = (): string => formatDay(todayDay());

/** Wall-clock now, aligned to the pinned day when overridden so relative times stay consistent. */
export function now(): Date {
  const real = new Date();
  if (!override) return real;
  const [y, m, d] = override.split('-').map(Number) as [number, number, number];
  return new Date(y, m - 1, d, real.getHours(), real.getMinutes(), real.getSeconds());
}
